/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_ExperienceInputs */

const en_us2_profile_row_experience = /** @type {(inputs: Profile_Row_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experience with weights`)
};

const pt_br2_profile_row_experience = /** @type {(inputs: Profile_Row_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiência com pesos`)
};

const es_419_profile_row_experience = /** @type {(inputs: Profile_Row_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiencia con pesas`)
};

const pt_pt2_profile_row_experience = /** @type {(inputs: Profile_Row_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiência com pesos`)
};

const fr_fr2_profile_row_experience = /** @type {(inputs: Profile_Row_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expérience en musculation`)
};

const de_de2_profile_row_experience = /** @type {(inputs: Profile_Row_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahrung mit Gewichten`)
};

const it_it2_profile_row_experience = /** @type {(inputs: Profile_Row_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperienza con i pesi`)
};

/**
* | output |
* | --- |
* | "Experience with weights" |
*
* @param {Profile_Row_ExperienceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_experience = /** @type {((inputs?: Profile_Row_ExperienceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_ExperienceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_experience(inputs)
	if (locale === "es-419") return es_419_profile_row_experience(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_experience(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_experience(inputs)
	if (locale === "de-DE") return de_de2_profile_row_experience(inputs)
	if (locale === "it-IT") return it_it2_profile_row_experience(inputs)
	return en_us2_profile_row_experience(inputs)
});
export { profile_row_experience as "profile.row_experience" }